﻿import * as React from "react";
import { IActiveSectionProps } from "../../SmartToolsRoot";
import { IBaseSectionProps } from "./IBaseSectionProps";
import { ODE } from "./Components";

export const ODESection: React.FunctionComponent<IBaseSectionProps> = (
    props,
): React.ReactElement => {
    const bindOnClick = (): void => {
        const messengerComponent: React.ReactNode = <ODE />;

        const activeProps: IActiveSectionProps = {
            moduleID: props.moduleID,
            sectionType: props.sectionType,
            subWindow: {
                body: messengerComponent,
                horizontalPos: `Center`,
                isDominant: false,
                moduleID: props.moduleID,
                subWindowKey: `odeWindow`,
                title: `Data Exporter`,
                verticalPos: `Center`,
            },
        };

        props.toggleSection(activeProps, activeSectionsComparer);
    };

    // This function is passed to the toggleSection function, and is used check if the other active sections should be active or not.
    const activeSectionsComparer = (
        activeSections: IBaseSectionProps[],
    ): IBaseSectionProps[] => {
        for (let i = 0; i < activeSections.length; i++) {
            if (activeSections[i].sectionType === `odeWindow`) {
                activeSections.splice(i, 1);
                i--;
            }
        }

        return activeSections;
    };

    const isActiveCSS: string = props.isActive ? `selected` : ``;

    return (
        <div className={`tab-section ${isActiveCSS}`} onClick={bindOnClick}>
            <img
                alt={props.name}
                src={`/Images/Icon?icon=${props.moduleID}&folder=Module`}
            />
        </div>
    );
};
